/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
export type FieldValue = string | boolean | undefined;

export type FormIdentifier = string;

enum INPUT {
    CHECKBOX = 'checkbox',
    PASSWORD = 'password',
    RADIO = 'radio',
    SELECT = 'select',
    TEL = 'tel',
    TEXT = 'text',

    HIDDEN = 'hidden',
    NONE = 'none',
}

enum YN {
    Y = 'Y',
    N = 'N',
}

/**
 * Form field description
 */
interface IFormFieldBase {
    name: string;
    type: INPUT;
    caption: string;
    /**
     * Disabled field value cannot be edited or submitted.
     */
    disabled?: boolean;
    /**
     * Default value of form field.
     * If defined, this value will be used to 'reset' form.
     */
    default?: string;
    /**
     * Allow enhanced (HTML) formatting of captions.
     */
    richText?: boolean;
    /**
     * Current value of form field
     */
    value?: FieldValue;
    handler?: string;
    /* validation error message */
    error?: string;
}

interface IOptionsFormField extends IFormFieldBase {
    type: INPUT.RADIO | INPUT.SELECT;
    /**
     * Value / Customization for FormFields
     */
    options: Array<{
        value: string;
        text?: string;
    }>;
    value?: string;
}

interface ICheckboxFormField extends IFormFieldBase {
    type: INPUT.CHECKBOX;
    value?: boolean;
}

interface IAnyFormField extends IFormFieldBase {
    type: Exclude<INPUT, INPUT.CHECKBOX | INPUT.RADIO | INPUT.SELECT>;
    placeholder?: string;
    value?: string;
}

type IFormField = ICheckboxFormField | IOptionsFormField | IAnyFormField;

export { IFormFieldBase, IAnyFormField, ICheckboxFormField, IOptionsFormField, IFormField };

interface IFormConfiguration {
    action?: string;
    id: string;
    method?: string;
    title: string;
    submitCaption: string;
    submitDisabled?: boolean;
    savePassword?: string;
    passwordVerifyDontMatch?: string;
    fields: IFormField[];
}

interface IFieldChangeSpec {
    form: FormIdentifier;
    name: string;
    value: FieldValue;
}

class FormValidationContext {
    form: FormIdentifier;
    errorMessage?: string;
    errors: {
        [field: string]: string;
    };
    constructor(form: FormIdentifier) {
        this.form = form;
        this.errors = {};
    }
}

export { IFormConfiguration as default, IFormConfiguration, IFieldChangeSpec, FormValidationContext, INPUT, YN };
